import "./carousel.css";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import ThumbnailSlider from "./ThumbnailSlider";
import AssetImageModal from "./AssetImageModal";
import { useCarousel } from "../../hooks/carousel/useCarousel";
import MainDisplay from "./MainDisplay";
import { CarouselContext } from "../../context/CarouselContext";
import { useEffect } from "react";


interface CarouselProps {
  images: any[];
  assetId: string;
  height?: string | number;
}

const Carousel: React.FC<CarouselProps> = ({ images, assetId, height }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const carouselState = useCarousel(images);
  const { uniqueImageTypes, selectedType, filteredImages, setCarouselAssetId } = carouselState
  
  useEffect(() => {
    setCarouselAssetId(assetId);
  }, [assetId, setCarouselAssetId]);

  const isUcOnly = ((uniqueImageTypes.length === 1 && ["img_uc_dewarp", "img_uc"].includes(filteredImages[0]?.imageType || '')) ||
    (uniqueImageTypes.length > 1 && ["img_uc_dewarp", "img_uc"].includes(selectedType)));


  return (
    <CarouselContext.Provider value={carouselState}>
      <Box sx={{
        width: "100%",
        height: height || '100%',
        minHeight: isMobile ? "250px" : "400px",
        margin: "0 auto",
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        p: isMobile ? "8px" : "20px 10px",
        borderRadius: 2,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {filteredImages.length > 0 &&
          <MainDisplay />
        }
        {!isUcOnly && (
          <ThumbnailSlider />
        )}
        <AssetImageModal />
      </Box>
    </CarouselContext.Provider>
  );
};

export default Carousel;
